import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { DateTime } from 'luxon'


import { SessionStorage } from '../../../common/cookie-storage'
import { STORAGEKEYS } from '../../../common/keys'
import { UseChangeLoadingScreenTextBasedOnSecondsProps } from '../WaitingScreensProps'
import { AppState } from '../../../store'
import { ILoaderConfigObjectModel } from '../../../store/types'


const useChangeLoadingScreenTextBasedOnSeconds = (props: UseChangeLoadingScreenTextBasedOnSecondsProps) => {
   const sessionStorage = new SessionStorage()
   const { loaderScreenType: LOADER_SCREEN_TYPE } = props
   const currentSteps = useSelector((state: AppState) => state.lenConfigState.loadersConfig[LOADER_SCREEN_TYPE])

   const intervalRef = useRef<NodeJS.Timeout | null>(null)
   const MAX_SECONDS_FROM_STEPS = Math.max(...currentSteps.map(s => (s.to ?? s.from)))
   const LAST_STEP = currentSteps[currentSteps.length - 1]


   
   //#region ========================================= INICJALIZACJA =========================================
   const getStartTime = (): DateTime => {
      const stored = sessionStorage.get(STORAGEKEYS.CHANGE_LOADER_TEXT_START_TIME)

      if (stored) {
         return DateTime.fromISO(stored)
      }

      const now = DateTime.now()
      sessionStorage.add(STORAGEKEYS.CHANGE_LOADER_TEXT_START_TIME, now.toISO()!)

      return now
   }

   const getInitialSeconds = (): number => {
      const startTime = getStartTime()
      const now = DateTime.now()

      return Math.floor(now.diff(startTime, 'seconds').seconds)
   }


   const initialSeconds = (() => {
      const s = getInitialSeconds()
      return Math.min(s, MAX_SECONDS_FROM_STEPS)
   })()

   const calculateFinalStep = (time: number): ILoaderConfigObjectModel => {
      return currentSteps.find(step => time >= step.from && (step.to === null || time < step.to)) || currentSteps[currentSteps.length - 1]
   }
   
   const [seconds, setSeconds] = useState(initialSeconds)
   const [currentStep, setCurrentStep] = useState<ILoaderConfigObjectModel>(() => calculateFinalStep(initialSeconds))
   
   //#endregion


   //#region ================================================= EFEKTY =================================================
   useEffect(() => {
      const startTime = getStartTime()
  
      intervalRef.current = setInterval(() => {
         const now = DateTime.now()
         const elapsedSeconds = Math.floor(now.diff(startTime, 'seconds').seconds)
         
         // jeśli przekroczyliśmy max → stopujemy wszystko
         if (elapsedSeconds >= MAX_SECONDS_FROM_STEPS) {
            if (seconds !== MAX_SECONDS_FROM_STEPS) {
               setSeconds(MAX_SECONDS_FROM_STEPS)
               setCurrentStep(LAST_STEP)
            }

            if (intervalRef.current) {
               clearInterval(intervalRef.current)
            }
   
            return
         }
   
         setSeconds(elapsedSeconds)
      }, 1000)
 
  
      return () => {
         if (intervalRef.current) {
           clearInterval(intervalRef.current)
         }
      }
   }, []) // eslint-disable-line



   useEffect(() => {
      const nextStep = calculateFinalStep(seconds)
  
      if (nextStep !== currentStep) {
        setCurrentStep(nextStep)
      }
   }, [seconds, currentSteps]) // eslint-disable-line
  
   //#endregion ==========================================================================================================

   return {
      heading: currentStep.heading,
      description: currentStep.description,
      seconds
   }
}

export default useChangeLoadingScreenTextBasedOnSeconds